// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import moment from 'moment';
export const formatTimeDiff = (timeDiff: number): string => {
  const totalSeconds = Math.floor(timeDiff / 1000);
  const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  const minutes = Math.floor((totalSeconds / 60) % 60)
    .toString()
    .padStart(2, '0');
  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export const secondsToTimeFormat = (timeDiff: number): string => {
  try {
    const duration = moment.duration(timeDiff, 'seconds');
    // Extract the individual components of the duration
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    // Format the duration as "1d 23h 34m 45s"
    if (days > 0 || hours > 0) {
      return `${days * 24 + hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else if (seconds > 0) {
      return `${seconds}s`;
    }
    return '-';
  } catch {
    return '-';
  }
};

export const convertTimeToSeconds = (time: string): number => {
  const durationString = time; // Replace with your duration value

  const durationParts = durationString.split(':');

  let totalSeconds = 0;

  if (durationParts.length === 3) {
    // Format: "hh:mm:ss"
    const [hoursString, minutesString, secondsString] = durationParts;
    const hours = parseInt(hoursString, 10);
    const minutes = parseInt(minutesString, 10);
    const seconds = parseInt(secondsString, 10);
    totalSeconds = hours * 3600 + minutes * 60 + seconds;
  } else if (durationParts.length === 2) {
    // Format: "mm:ss"
    const [minutesString, secondsString] = durationParts;
    const minutes = parseInt(minutesString, 10);
    const seconds = parseInt(secondsString, 10);
    totalSeconds = minutes * 60 + seconds;
  }
  return totalSeconds;
};

export const calculateDurationBetweenStartAndStopTime = (
  selectedStartTime: any,
  selectedStopTime: any,
  showFormat?: boolean
): string => {
  const startTime = moment(selectedStartTime);
  const stopTime = moment(selectedStopTime);
  if (startTime?.isValid?.() && stopTime?.isValid()) {
    if (stopTime.isBefore(startTime)) {
      return '';
    }
    const duration = moment.duration(stopTime.diff(startTime));
    const hours = Math.floor(duration.as('hours'));
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    // Format the duration in "hh:mm:ss" format
    if (showFormat) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }
    return `${hours}:${minutes}:${seconds}`;
  }

  return '';
};

export const CCMCardSecondsToTimeFormat = (timeDiff: number): string => {
  try {
    const duration = moment.duration(timeDiff, 'seconds');
    // Extract the individual components of the duration
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    // Format the duration as "1d 23h 34m 45s"
    if (days > 0 || hours > 0) {
      return `${days * 24 + hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else if (seconds > 0) {
      return `${seconds}s`;
    }
    return '0m';
  } catch {
    return '0';
  }
};
